/* assets/quick-add-modal.js (Lavora)
   1) Kart uzerindeki sepet ikonu: tek tiklamada tek ekleme
   2) Renk secenekleri: '+N Renk' etiketi ve 'Diger Renkler' penceresi
   3) Urun sayfasi: gorsel buyutme penceresi (lightbox) */
(() => {
  /* ---------- Ortak ---------- */
  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) {
      let j = null; try { j = await res.json(); } catch {}
      throw new Error(j?.description || j?.message || 'Ürün sepete eklenemedi.');
    }
    const item = await res.json();
    const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return { item, cart };
  }

  function toast(msg) {
    let t = document.getElementById('atc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'atc-toast';
      Object.assign(t.style, {
        position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)',
        background: 'rgba(20,20,20,.95)', color: '#fff', padding: '10px 14px',
        zIndex: 100005, fontSize: '13px', letterSpacing: '.02em', transition: 'opacity .2s'
      });
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(toast._t);
    toast._t = setTimeout(() => { t.style.opacity = '0'; }, 2200);
  }

  function esc(s) { return String(s ?? '').replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m])); }

  /* ---------- 1) Kart sepet ikonu ---------- */
  const QUICK_ADD_SEL = '.js-product-card-quick-view-button, .product-card__quick-view-text-button, .product-card__quick-view-button';
  let busy = false;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(QUICK_ADD_SEL);
    if (!btn) return;
    const variantId = btn.dataset.variant || btn.dataset.variantId;
    if (!variantId) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    btn.setAttribute('disabled', 'disabled');
    try { await addToCart(variantId); }
    catch (err) { toast(err.message); }
    finally { btn.removeAttribute('disabled'); setTimeout(() => { busy = false; }, 600); }
  }, true);

  /* ---------- 2) Renk secenekleri ---------- */
  let placeQueued = false;
  function placeChips() {
    placeQueued = false;
    document.querySelectorAll('.product-card [data-lavora-colors]:not([data-placed])').forEach((el) => {
      const main = el.closest('.product-card')?.querySelector('.product-card__main');
      if (main) { main.appendChild(el); el.dataset.placed = '1'; }
    });
  }
  function queuePlace() { if (!placeQueued) { placeQueued = true; requestAnimationFrame(placeChips); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeChips);
  else placeChips();
  new MutationObserver(queuePlace).observe(document.documentElement, { childList: true, subtree: true });

  let modal = null;
  function closeModal() {
    if (!modal) return;
    modal.remove();
    modal = null;
    document.documentElement.classList.remove('lavora-lock');
    document.removeEventListener('keydown', onModalKey);
  }
  function onModalKey(e) { if (e.key === 'Escape') closeModal(); }

  function openModal(items) {
    closeModal();
    modal = document.createElement('div');
    modal.className = 'lavora-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Diğer renkler');
    modal.innerHTML = `
      <div class="lavora-modal__backdrop" data-lavora-close></div>
      <div class="lavora-modal__panel">
        <div class="lavora-modal__head">
          <span class="lavora-modal__title">Diğer Renkler</span>
          <button type="button" class="lavora-modal__close" aria-label="Kapat" data-lavora-close>&times;</button>
        </div>
        <div class="lavora-modal__grid">
          ${items.map(it => `
            <div class="lavora-opt${it.cur ? ' is-current' : ''}${it.a ? '' : ' is-sold-out'}">
              <a class="lavora-opt__img" href="${esc(it.u)}">
                ${it.i ? `<img src="${esc(it.i)}" alt="${esc(it.t)}" loading="lazy">` : ''}
                ${it.cur ? '<span class="lavora-opt__badge">Seçili</span>' : ''}
              </a>
              <a class="lavora-opt__title" href="${esc(it.u)}">${esc(it.t)}</a>
              <div class="lavora-opt__price">
                <span class="lavora-opt__now">${esc(it.p)}</span>
                ${it.c ? `<s class="lavora-opt__was">${esc(it.c)}</s>` : ''}
              </div>
              ${it.a
                ? `<button type="button" class="lavora-opt__btn" data-lavora-add="${esc(it.v)}">Sepete Ekle</button>`
                : `<button type="button" class="lavora-opt__btn" disabled>Tükendi</button>`}
            </div>`).join('')}
        </div>
      </div>`;
    document.body.appendChild(modal);
    document.documentElement.classList.add('lavora-lock');
    document.addEventListener('keydown', onModalKey);
    modal.querySelector('.lavora-modal__close')?.focus();
  }

  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('.js-lavora-chip');
    if (chip) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      const raw = chip.closest('[data-lavora-colors]')?.querySelector('.lavora-colors__data')?.textContent;
      try { openModal(JSON.parse(raw || '[]')); } catch { toast('Renkler yüklenemedi.'); }
      return;
    }
    if (!modal) return;
    if (e.target.closest('[data-lavora-close]')) { closeModal(); return; }
    const addBtn = e.target.closest('[data-lavora-add]');
    if (addBtn && modal.contains(addBtn)) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (addBtn.dataset.loading) return;
      addBtn.dataset.loading = '1';
      const label = addBtn.textContent;
      addBtn.textContent = 'Ekleniyor…';
      try { await addToCart(addBtn.dataset.lavoraAdd); closeModal(); }
      catch (err) { addBtn.textContent = label; delete addBtn.dataset.loading; toast(err.message); }
    }
  }, true);

  /* ---------- 3) Urun sayfasi gorsel buyutme (lightbox) ---------- */
  if (!document.body || !document.body.classList.contains('template-product')) {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }

  function initLightbox() {
    if (!document.body.classList.contains('template-product') || initLightbox.done) return;
    initLightbox.done = true;

    const EXCLUDE = '.product-card, .lavora-modal, .lv-lb, [data-zoom-modal], .quick-view, .product-recommendations';
    const baseOf = (u) => (u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.[a-z0-9]+$)/i, '');
    const bigOf = (u) => {
      if (!u) return u;
      if (/_\d+x\d*(?=\.[a-z0-9]+(\?|$))/i.test(u)) return u.replace(/_\d+x\d*(?=\.[a-z0-9]+(\?|$))/i, '_1600x');
      if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$11600');
      return u;
    };

    function galleryImages() {
      const seen = new Set();
      const list = [];
      document.querySelectorAll('img.product-media__image').forEach((img) => {
        if (img.closest(EXCLUDE)) return;
        const u = img.dataset.src || img.getAttribute('src') || '';
        if (!u || (/_10x\./.test(u) && !img.dataset.src)) return;
        const b = baseOf(u);
        if (seen.has(b)) return;
        seen.add(b);
        list.push({ src: bigOf(u), base: b, alt: img.alt || '' });
      });
      return list;
    }

    let lb = null, items = [], idx = 0;

    function render() {
      const it = items[idx];
      const img = lb.querySelector('.lv-lb__img');
      img.classList.add('is-loading');
      img.onload = () => img.classList.remove('is-loading');
      img.src = it.src;
      img.alt = it.alt;
      const c = lb.querySelector('.lv-lb__count');
      if (c) c.textContent = (idx + 1) + ' / ' + items.length;
    }
    function go(d) { if (items.length < 2) return; idx = (idx + d + items.length) % items.length; render(); }
    function close() {
      if (!lb) return;
      lb.remove(); lb = null;
      document.documentElement.classList.remove('lavora-lock');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    }
    function open(startBase) {
      items = galleryImages();
      if (!items.length) return;
      idx = Math.max(0, items.findIndex(i => i.base === startBase));
      const multi = items.length > 1;
      lb = document.createElement('div');
      lb.className = 'lv-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Ürün görseli');
      lb.innerHTML = `
        <div class="lv-lb__bg" data-lb-close></div>
        <div class="lv-lb__box">
          <img class="lv-lb__img" alt="">
          <button type="button" class="lv-lb__close" aria-label="Kapat" data-lb-close>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
          </button>
          ${multi ? '<div class="lv-lb__count"></div>' : ''}
        </div>
        ${multi ? `
          <button type="button" class="lv-lb__nav lv-lb__nav--prev" aria-label="Önceki görsel" data-lb-prev><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>
          <button type="button" class="lv-lb__nav lv-lb__nav--next" aria-label="Sonraki görsel" data-lb-next><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>` : ''}`;
      document.body.appendChild(lb);
      document.documentElement.classList.add('lavora-lock');
      document.addEventListener('keydown', onKey);
      render();
      lb.querySelector('.lv-lb__close')?.focus();

      // Telefonda kaydirarak gecis
      let sx = null;
      lb.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        sx = null;
      }, { passive: true });
    }

    // Kaydirma hareketini tiklama saymamak icin
    let downX = 0, downY = 0;
    document.addEventListener('pointerdown', (e) => { downX = e.clientX; downY = e.clientY; }, true);

    document.addEventListener('click', (e) => {
      // Acik pencere icindeki tiklamalar
      if (lb) {
        if (e.target.closest('[data-lb-close]')) { e.preventDefault(); close(); return; }
        if (e.target.closest('[data-lb-prev]')) { e.preventDefault(); go(-1); return; }
        if (e.target.closest('[data-lb-next]')) { e.preventDefault(); go(1); return; }
        return;
      }
      // Galeri gorseline tiklama
      const img = e.target.closest('img.product-media__image');
      if (img && !img.closest(EXCLUDE)) {
        if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        open(baseOf(img.dataset.src || img.getAttribute('src')));
        return;
      }
      // Temanin buyutec butonu
      const zoomBtn = e.target.closest('[data-zoom-modal-toggle], [data-target^="ZoomMediaModal"], [data-js-toggle^="ZoomMediaModal"], .js-zoom-button');
      if (zoomBtn && !zoomBtn.closest('[data-zoom-modal]')) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const active = document.querySelector('.swiper-slide-active img.product-media__image, .is-active img.product-media__image');
        open(active && !active.closest(EXCLUDE) ? baseOf(active.dataset.src || active.getAttribute('src')) : null);
      }
    }, true);
  }
})();
